import { ObjectFieldsChecker } from "../../../../../tools/ObjectFieldsChecker";
import { PiggyBankBenefitAtOpenDto } from "../../../../networking/data/responses/piggybank/PiggyBankBenefitAtOpenDto";

export class PiggyBankBenefitAtOpen {
    public readonly id: string;
    public readonly name: string;
    public readonly imageUrl: string;
    public readonly buildingPurchaseCouponDurationInHours: number;
    public readonly buildingPurchaseCouponDiscountPercentage: number;

    public constructor(dto: PiggyBankBenefitAtOpenDto) {
        this.validateDto(dto);
        this.id = dto.id;
        this.name = dto.name;
        this.imageUrl = dto.imageUrl;
        this.buildingPurchaseCouponDurationInHours = dto.buildingPurchaseCouponDurationInHours;
        this.buildingPurchaseCouponDiscountPercentage = dto.buildingPurchaseCouponDiscountPercentage;
    }

    private validateDto(dto: PiggyBankBenefitAtOpenDto): void {
        ObjectFieldsChecker.throwIfInvalidFields(dto, [
            "id",
            "name",
            "imageUrl"
        ]);
    }
}
